import type { ItemRecord } from '../types';
import { normalizeText } from './semantic';

export type PlaceKind = 'location' | 'group';

export function repairedLegacyMetadata(item: ItemRecord) {
  const locationNote = item.locationNote.trim();
  const previousGroup = item.locationGroup.trim();
  const locationTerms = new Set([normalizeText(locationNote), normalizeText(previousGroup)].filter(Boolean));
  const synonyms = item.synonyms.filter((synonym) => !locationTerms.has(normalizeText(synonym)));
  const locationGroup = locationNote;
  if (locationGroup === previousGroup && synonyms.length === item.synonyms.length) return null;
  return { locationGroup, synonyms };
}

export function renamedPlaceValues(item: ItemRecord, kind: PlaceKind, previousName: string, nextName: string) {
  if (kind === 'group') {
    if (item.locationGroup.trim() !== previousName) return null;
    return { locationNote: item.locationNote, locationGroup: nextName };
  }
  if (item.locationNote.trim() !== previousName) return null;
  const followsLocation = normalizeText(item.locationGroup) === normalizeText(previousName);
  return { locationNote: nextName, locationGroup: followsLocation ? nextName : item.locationGroup };
}
